export default "__VITE_ASSET__BsWQIW3y__"